var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _vm.isFillBlank
          ? _c("FillBlank", {
              attrs: {
                questionId: _vm.question.id,
                isQuestionPaper:
                  _vm.submission && _vm.submission.isQuestionPaper,
              },
            })
          : _vm._e(),
        _vm.isMultipleChoice
          ? _c("MultipleChoice", { attrs: { question: _vm.question } })
          : _vm._e(),
        _vm.isSingleChoice
          ? _c("SingleChoice", { attrs: { question: _vm.question } })
          : _vm._e(),
        _vm.isTrueFalseChoice
          ? _c("TrueFalseChoice", {
              attrs: {
                question: _vm.question,
                isCorrectHidden: "",
                isStudentAnswerCorrectShown: _vm.isStudentAnswerCorrectShown,
              },
            })
          : _vm._e(),
        _vm.isMatching
          ? _c("LinkQuestion", {
              attrs: {
                question: _vm.question,
                isQuestionPaper:
                  _vm.submission && _vm.submission.isQuestionPaper,
              },
            })
          : _vm._e(),
        _vm.isDragDrop
          ? _c("DragDrop", {
              attrs: {
                question: _vm.question,
                isQuestionPaper:
                  _vm.submission && _vm.submission.isQuestionPaper,
                submission: _vm.submission,
              },
            })
          : _vm._e(),
        _vm.isDropdown
          ? _c("Dropdown", {
              attrs: {
                question: _vm.question,
                isQuestionPaper:
                  _vm.submission && _vm.submission.isQuestionPaper,
                submission: _vm.submission,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm.submission &&
    !_vm.submission.isQuestionPaper &&
    !_vm.submission.isStudentWork &&
    _vm.question.correct &&
    !_vm.isTrueFalseChoice &&
    !_vm.isCorrectHidden
      ? _c("div", { staticClass: "mt-1" }, [
          _c("span", { staticClass: "font-weight-medium" }, [
            _vm._v("Đáp án: "),
          ]),
          _c("span", {
            staticClass: "green--text",
            domProps: { innerHTML: _vm._s(_vm.correct) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }